import React from 'react';
import { productServiceWithInHouseData } from 'config/api';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { PROMO_DISCOUNT_TYPE, SHIPPING_AWARD_TYPE } from 'constants/index';
import Drawer from 'sharedComponents/Drawer';
import Preloader from 'sharedComponents/Preloader';
import { getElementStringFromHtmlString, camelCaseToSpaceDelimited } from '../../utils';

const PromoInfo = ({ classes, promotions }) => {
  if (!promotions?.length) return null;
  const [modalContent, setModalContent] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);

  const getModalContent = (htmlResponse) => {
    const content = getElementStringFromHtmlString(htmlResponse, '.outer,[class^="disc"]');
    const promoImage = getElementStringFromHtmlString(htmlResponse, 'img');
    return `${promoImage}${content}`;
  };

  const showPromoModal = async (promoDetailsLink) => {
    if (!promoDetailsLink) {
      // modalContent passed as dangerouslySetInnerHTML prop to Drawer because usually we
      // pass dynamic HTML that is fetched from NMO/BGO resource. Since that, fallback
      // content is an HTML string. To be able to pass it through dangerouslySetInnerHTML
      setModalContent('<div class="title_two">No details available</div>');
      return;
    }
    setIsLoading(true);
    try {
      const response = await productServiceWithInHouseData.post('/promotions', { promoDetailsLink });
      setIsLoading(false);
      const modalContent = getModalContent(response.data);
      if (modalContent.length) {
        setModalContent(modalContent);
      }
    } catch (e) {
      setIsLoading(false);
    }
  };

  const getTitleByType = (type, awardType) => {
    let title = `${camelCaseToSpaceDelimited(awardType)} Promotion`;

    if (type === PROMO_DISCOUNT_TYPE) {
      title = 'Percent Off Promotion';
    } else if (awardType === SHIPPING_AWARD_TYPE) {
      title = 'Promotion Details';
    }

    return title;
  };

  return (
    <div className={classes.container}>
      {!!isLoading && <Preloader />}
      {promotions.map(({ type, awardType, id, promoDetailsLink }) => (
        <Typography
          onClick={() => showPromoModal(promoDetailsLink)}
          className={classes.promoTitle}
          key={id}
          data-testid="promo-title"
        >
          {getTitleByType(type, awardType)}
        </Typography>
      ))}
      {modalContent && (
        <Drawer open title="Promotion Details" onClose={() => setModalContent(null)} data-testid="promotion-modal">
          <div
            className={classes.modalContainer}
            //eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: modalContent }}
            data-testid="drawer-inner-container"
          />
        </Drawer>
      )}
    </div>
  );
};

PromoInfo.propTypes = {
  classes: PropTypes.shape({}),
  promotions: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      productHTML: PropTypes.string,
      awardType: PropTypes.string,
      id: PropTypes.string,
    }),
  ),
};

PromoInfo.defaultProps = {
  classes: {},
  promotions: [],
};

export default PromoInfo;
